module.exports = __webpack_public_path__ + "static/img/image_solutions_optics_10.5c22aca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_optics_10.png
// module id = g4hu
// module chunks = 10